import { Stack, useTheme } from '@mui/material';
import React from 'react';
import EmptyStateOverview from 'v2/components/EmptyStateOverview/EmptyStateOverview';
import { FULL_CHART_HEIGHT } from 'v2/pages/Dashboard/charts/ChartCard';

interface Props {
  title: string;
  content: string;
}

/**
 * Shown in place of a dashboard chart when there is nothing to plot — either the window holds no
 * events (empty) or the fetch failed (error). The caller picks the title and content copy, which is
 * all that differs between the two cases. Keeps the chart's height so the card does not resize once
 * data starts coming in or a retry succeeds.
 */
const ChartStateMessage: React.FC<Props> = ({ title, content }) => {
  const theme = useTheme();

  return (
    <Stack
      justifyContent="center"
      height={FULL_CHART_HEIGHT}
      padding={2}
      borderRadius={1}
      bgcolor={theme.custom.background.level2}
    >
      <EmptyStateOverview
        title={title}
        titleVariant="subtitle2"
        titleColor="textSecondary"
        content={content}
        contentVariant="body2"
        sx={{ height: 'auto' }}
      />
    </Stack>
  );
};

export default ChartStateMessage;
